import React from 'react';
import { Button } from '@framework-controls/core';
import css from './MenuBackBtn.module.scss';
import { strings } from 'src/localization';
import { IconBackArrow } from 'src/content/icons';
import classNames from 'classnames';

interface IProps {
    theme: string;
    menuOpen?: boolean;
    extraPadding?: boolean;
    click: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

const MenuBackBtn = (props: IProps) => {
    const wrapper = classNames(
        css.wrapper,
        {
            [css.extraPadding]: props.extraPadding,
        },
        {
            [css.menuOpen]: props.menuOpen,
        },
    );

    const menuIcon = classNames(
        css.menuIcon,
        {
            [css.menuIconCadillac]: props.theme === 'cadillac',
        },
    );

    return <div className={wrapper}>
        <Button
            id='backBtn'
            onClick={props.click}
            variant={'menuBackBtn'}
            type={'custom'}
            tooltip={strings.BackTitle}
        >
            <div className={menuIcon}>
                {<IconBackArrow style={{ height: '2.5rem' }} />}
            </div>
            <div className={css.menuLit}>{strings.Back}</div>
        </Button>
    </div>;
};

export default MenuBackBtn;